<template>
  <div>
    <!-- 遮罩层 -->
    <div
        class="nav-mask"
        :class="{ show: isNavOpen }"
        @click="closeNav"
    />

    <!-- 汉堡菜单按钮 -->
    <button class="hamburger-btn" @click="toggleNav">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
      </svg>
    </button>

    <!-- 左侧抽屉导航 -->
    <div class="page-navigator" :class="{ open: isNavOpen }">
      <!-- 导航头部 -->
      <div class="nav-header">
        <div class="nav-title">功能导航</div>
        <button class="close-btn" @click="closeNav">×</button>
      </div>

      <!-- 导航菜单 -->
      <div class="nav-menu">
        <div class="nav-items">
          <div
              v-for="item in navItems"
              :key="item.path"
              class="nav-item"
              @click="navigateTo(item.path)"
          >
            <span class="nav-icon">{{ item.icon }}</span>
            <span class="nav-label">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNavigator',
  data() {
    return {
      isNavOpen: false,
      navItems: [
        { path: '/', label: '图片水印', icon: '🏠' },
        { path: '/EImage', label: '图片压缩', icon: '🖼️' },
        { path: '/EPdf', label: 'PDF压缩', icon: '📄' },
      ]
    }
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },

    closeNav() {
      this.isNavOpen = false;
    },

    navigateTo(path) {
      // 如果是当前页面，则不跳转
      if (this.$route.path === path) {
        this.closeNav();
        return;
      }

      // 使用路由跳转
      this.$router.push(path);
      this.closeNav();
    }
  },
  mounted() {
    // 点击其他地方关闭导航
    document.addEventListener('click', (e) => {
      if (this.isNavOpen && !e.target.closest('.page-navigator') &&
          !e.target.closest('.hamburger-btn')) {
        this.closeNav();
      }
    });
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f7fa;
  color: #333;
  transition: all 0.3s ease;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 遮罩层 */
.nav-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.nav-mask.show {
  opacity: 1;
  visibility: visible;
}

/* 抽屉导航容器 */
.page-navigator {
  position: fixed;
  top: 0;
  left: -280px;
  width: 280px;
  height: 100vh;
  background: white;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  transition: left 0.3s ease;
  display: flex;
  flex-direction: column;
}

.page-navigator.open {
  left: 0;
}

/* 导航头部 */
.nav-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #4285f4;
  color: white;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* 导航菜单 */
.nav-menu {
  flex: 1;
  padding: 10px 0;
  overflow-y: auto;
}

.nav-items {
  display: flex;
  flex-direction: column;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  transition: background 0.2s;
  color: #555;
  border-left: 4px solid transparent;
}

.nav-item:hover {
  background: #f8f9fa;
}

.nav-item.active {
  background: #e8f0fe;
  color: #4285f4;
  font-weight: 500;
  border-left-color: #4285f4;
}

.nav-icon {
  margin-right: 12px;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.nav-label {
  font-size: 15px;
}

/* 主内容区域 */
.main-content {
  flex: 1;
  padding: 20px;
  transition: margin-left 0.3s ease;
}

.main-content.shifted {
  margin-left: 280px;
}

/* 汉堡菜单按钮 */
.hamburger-btn {
  position: fixed;
  top: 50%;
  left: 0;
  width: 40px;
  height: 40px;
  background: #4285f4;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  z-index: 997;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.hamburger-btn:hover {
  background: #3367d6;
  transform: scale(1.05);
}

/* 页面标题 */
.page-title {
  margin-top: 80px;
  margin-bottom: 30px;
  text-align: center;
  font-size: 32px;
  color: #333;
}

.page-description {
  text-align: center;
  color: #666;
  margin-bottom: 40px;
  font-size: 18px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* 功能卡片 */
.feature-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.feature-card {
  background: white;
  border-radius: 12px;
  padding: 25px;
  width: calc(50% - 20px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.feature-card h3 {
  color: #4285f4;
  margin-bottom: 15px;
  font-size: 20px;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-navigator {
    width: 250px;
    left: -250px;
  }

  .main-content.shifted {
    margin-left: 0;
  }

  .feature-card {
    width: 100%;
  }

  .page-title {
    font-size: 26px;
  }

  .page-description {
    font-size: 16px;
  }
}
</style>